<template>
   <div class="layout">
      <div class="layout__header">
         <div class="layout__title">
            <h3>Logs Imap</h3>
         </div>
         <div class="layout__controls">
            <div class="form-inline">
               <button @click="consultar" class="btn-info" type="button">
                  <i class="fa fa-search"></i><span>Buscar</span>
               </button>
            </div>
         </div>
      </div>
      <div class="card">
         <div class="card__content">
            <div class="form-inline">
               <label for="hoy">
                  <input type="radio" name="tipo_fecha" id="hoy" v-model="form.tipo_fecha" value="H"><span>Hoy</span>
               </label>
               <label for="ayer">
                  <input type="radio" name="tipo_fecha" id="ayer" v-model="form.tipo_fecha" value="A"><span>Ayer</span>
               </label>
               <label for="personalizado">
                  <input @change="changePersonalizado" type="radio" name="tipo_fecha" id="personalizado" v-model="form.tipo_fecha" value="P"><span>Personalizado</span>
               </label>
               <div v-show="form.tipo_fecha === 'P'" class="form-field">
                  <div class="datepicker-field">
                        <date-picker
                           v-model="form.desde"
                           type="date"
                           format="dd-MM-yyyy"
                           id="desde"
                        ></date-picker>
                        <label>Desde</label>
                  </div>
               </div>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                 <div class="datepicker-field">
                     <date-picker
                        v-model="form.hasta"
                        type="date"
                        format="dd-MM-yyyy"
                        id="hasta"
                     ></date-picker>
                     <label>Hasta</label>
                  </div>
              </div>
              <div class="form-field select">
                 <div class="select-field">
                    <select name="tipo" v-model="form.tipo" id="tipo">
                       <option value="C">Correos electrónicos</option>
                       <option value="E">Errores</option>
                    </select>
                    <label for="tipo">Tipo de consulta</label>
                 </div>
              </div>
            </div>
         </div>
      </div>
      <div class="card mt-2">
         <div class="card__content">
            <div v-if="tipoConsultado='C'" class="table-responsive">
               <vue-good-table :columns="[
                  {
                     label : 'Usuario',
                     field : 'usuario_imap',
                     filterable : true
                  },
                  {
                     label : 'Host',
                     field : 'host_imap',
                     filterable : true
                  },
                  {
                     label : 'Puerto',
                     field : 'host_port',
                     filterable : true
                  },
                  {
                     label : 'Comentario',
                     field : 'texto_plano',
                     filterable : true
                  },
                  {
                     label : 'Fecha',
                     field : 'fecha',
                     filterable : true
                  },
                  {
                     label : 'Emisor',
                     field : 'emisor',
                     filterable : true
                  },
                  {
                     label : 'Asunto',
                     field : 'asunto',
                     filterable : true
                  },
                  {
                     label : 'Receptores',
                     field : 'receptores',
                     filterable : true
                  },
                  {
                     label : 'Fecha de correo',
                     field : 'fecha_correo',
                     filterable : true
                  }
               ]"
               :pagination-options="{
                     enabled: false
                  }"
               :rows="logs"
               :search-options="{
                     enabled: true,
                     placeholder: 'Buscar...'
               }"
               styleClass="vgt-table">
               </vue-good-table>
            </div>
            <div class="table-responsive" v-else>
               <vue-good-table :columns="[
                  {
                     label : 'Usuario',
                     field : 'usuario_imap',
                     filterable : true
                  },
                  {
                     label : 'Host',
                     field : 'host_imap',
                     filterable : true
                  },
                  {
                     label : 'Puerto',
                     field : 'host_port',
                     filterable : true
                  },
                  {
                     label : 'Mensaje de error',
                     field : 'mensaje_error',
                     filterable : true
                  },
                  {
                     label : 'Fecha',
                     field : 'fecha',
                     filterable : true
                  }
               ]"
               :pagination-options="{
                     enabled: false
                  }"
               :rows="logs"
               :search-options="{
                     enabled: true,
                     placeholder: 'Buscar...'
               }"
               styleClass="vgt-table">
               </vue-good-table>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data : function () {
      return {
         form : {
            tipo_fecha : 'H',
            desde : '',
            hasta : '',
            tipo : 'C'
         },
         logs : [],
         tipoConsultado : 'C'
      };
   },
   methods : {
      changePersonalizado : function () {
         let desde = new Date();
         this.form.hasta = moment(new Date()).format('YYYY-MM-DD');
         desde.setDate(desde.getDate() - 7);
         this.form.desde = moment(desde).format('YYYY-MM-DD');
      },
      consultar : function () {
         let that = this;
         axios.get(url + '/logs-imap', {
            params : this.form
         }).then(function (response) {
            that.logs = response.data;
            that.tipoConsultado	 = that.form.tipo;
         });
      }
   }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logs/LogsImap.vue